<kui-modal size='md'
    class="details-modal"
    [title]="title"
    (onClose)="detachModal()"
    [actions]="modalActions">
    <div class="p-4">
        <key-form-builder [form]="data.form"
            [values]="data.values"></key-form-builder>
    </div>
</kui-modal>